<template>
  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-12 container-blue mb-15">
          <p class="text-xxxl text-bold">Project</p>
          <div class="row mt-20">
            <div class="col-12">
              <TotalProject :totalProject="totalProject" />
            </div>

            <div class="row mt-20">
              <div class="col-12">
                <CarouselProject />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-7">
      <div class="row">
        <div class="col-12 container-blue">
          <p class="text-xxxl text-bold">Issue</p>
          <div class="row mt-20">
            <div class="col-6">
              <div class="row">
                <div class="col-12">
                  <Issue
                    :openIssue="openIssue"
                    :closedIssue="closedIssue"
                    :inprogressIssue="inprogressIssue"
                    :totalIssue="totalIssue"
                  />
                </div>
                <div class="col-12">
                  <ChartProject />
                </div>
              </div>
            </div>
            <div class="col-6">
              <CardOpenIssue :issue="issue" />
            </div>
          </div>
        </div>
        <div class="col-12 mt-20">
          <BdayAndAbsent />
        </div>
      </div>
    </div>
    <div class="col-12 card-pengumuman">
      <Announcement />
    </div>
  </div>
</template>


<script>
import BdayAndAbsent from "@/components/Home/BdayAndAbsent.vue";
import TotalProject from "@/components/Home/TotalProject.vue";
import CarouselProject from "@/components/Home/CarouselProject.vue";
import Announcement from "@/components/Home/Announcement.vue";
import Issue from "@/components/Home/Issue.vue";
import ChartProject from "@/components/Home/ChartProject.vue";
import CardOpenIssue from "@/components/Home/CardOpenIssue.vue";
import axios from "axios";

export default {
  name: "Higlight",
  components: {
    BdayAndAbsent,
    TotalProject,
    CarouselProject,
    Announcement,
    Issue,
    CardOpenIssue,
    ChartProject,
  },
  data() {
    return {
      totalProject: [],
      issueData: [],
      openIssue: [],
      closedIssue: [],
      inprogressIssue: [],
      totalIssue: [],
      issue: [],
    };
  },
  methods: {
    setData(data) {
      this.totalProject = data.length;
      // console.log(data)
      var totalClosed = [];
      var totalInProgress = [];
      var totalOpen = [];
      var jumlahOpen;
      data.forEach((dataProject) => {
        totalClosed.push(dataProject.status_count.Closed);
        totalInProgress.push(dataProject.status_count["In Progress"]);
        jumlahOpen =
          dataProject.status_count.New + dataProject.status_count.Feedback;
        totalOpen.push(jumlahOpen);
      });

      var closed = totalClosed.reduce(function (a, b) {
        return a + b;
      }, 0);

      var inProgress = totalInProgress.reduce(function (a, b) {
        return a + b;
      }, 0);

      var open = totalOpen.reduce(function (a, b) {
        return a + b;
      }, 0);

      var issueTotal = closed + inProgress + open;

      this.openIssue = open;
      this.closedIssue = closed;
      this.inprogressIssue = inProgress;
      this.totalIssue = issueTotal;
    },
    setIssue(data) {
      this.issue = data;
    },
  },
  mounted() {
    var token = localStorage.token;
    document.body.classList.add("card-secondary");

    axios
      .get( "projects/summary")
      .then(
        (response) =>
          // handle success
          this.setData(response.data)
        // console.log(response.data)
      )
      .catch((error) =>
        // handle error
        console.log(error)
      );

    axios
      .get( "issues/recents")
      .then(
        (response) =>
          // handle success
          this.setIssue(response.data)
        // console.log(response.data)
      )
      .catch((error) =>
        // handle error
        console.log(error)
      );
  },
};
</script>

<style scoped>
.card-pengumuman {
  height: 300px;
  /* margin-bottom: 25px  !important; */
}

.container-blue {
  /* height: 1250px; */
}
</style>


// WEBPACK FOOTER //
// src/views/Higlight.vue